import { mediaQueries } from './mediaQueries';
import { css } from '@emotion/react';
import { linkStyle } from './linkStyle';
import { textStyle } from './textStyle';

export const global = css`
  body,
  pre {
    font-family: 'Helvetica Neue', Helvetica, 'Segoe UI', 'Hiragino Sans', 'メイリオ',
      'Meiryo, Osaka', 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
    ${textStyle('m', 'regular')}
  }

  a {
    ${linkStyle()}
  }

  /* stylelint-disable-next-line selector-id-pattern */
  html,
  body,
  /* Next.js */
  #__next,
  /* Storybook */
  #root {
    height: 100%;
  }

  /* NOTE: 印刷時にスクロールバーが表示されないようにする */
  ${mediaQueries.print} {
    body: {
      overflow-y: hidden;
    }
  }
`;
